<template>
  <div class="AppActionBarSelectionLabel" data-locator="selection-label">
    <AppTooltip>
      <template #activator="{props}">
        <app-button
          data-locator="unselect-all-bar-item"
          type="icon"
          variant="outlined"
          v-bind="props"
          @click="onClearSelection"
        >
          <app-icon-ds icon="xmark" size="sm" />
        </app-button>
      </template>
      {{ $t('common.clearSelection') }}
    </AppTooltip>
    <span class="text--bold text-grey-700" v-t="{ path: selectedItemsLabelPath, plural: totSelectedDocuments, args: { count : totSelectedDocuments } }"></span>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

export default {
  name: 'AppActionBarSelectionLabel',
  components: {
    AppTooltip,
  },
  props: {
   totSelectedDocuments: {
     type: Number,
     required: true,
   },
   selectedItemsLabelPath: {
     type: String,
     default: 'common.selectedItems',
   },
  },
  methods: {
    onClearSelection () {
      this.$emit('clear-selection')
    },
  },
}
</script>

<style lang="scss" scoped>
.AppActionBarSelectionLabel {
  align-items: center;
  column-gap: 8px;
  display: flex;
  justify-items: center;
  white-space: nowrap;
}
</style>
